<template>
  <dialog-v2
    :show="show"
    :title="title"
    @save="save"
    @close="$emit('close')">
    <template slot="content">
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            v-model="form.from_name"
            v-validate="'required|max:100'"
            data-vv-name="from_name"
            :data-vv-scope="validationScope"
            data-vv-as="nombre"
            :error-messages="errors.collect(`${validationScope}.from_name`)"
            label="Nombre"
            color="black"/>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            v-model="form.email"
            v-validate="'required|email|max:100'"
            data-vv-name="email"
            :data-vv-scope="validationScope"
            data-vv-as="email"
            :error-messages="errors.collect(`${validationScope}.email`)"
            label="Email"
            color="black"/>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            v-model="form.forwarding"
            v-validate="'required|email|max:100'"
            data-vv-name="forwarding"
            :data-vv-scope="validationScope"
            data-vv-as="responde a"
            :error-messages="errors.collect(`${validationScope}.forwarding`)"
            label="Responde a"
            color="black"/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import _ from 'lodash';
import DialogV2 from '@/components/global/DialogV2';
import { setTimeout } from 'timers';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    email: {
      type: Object,
      required: false,
    },
    validationScope: {
      type: String,
      default: 'companyEmail',
    },
  },
  components: {
    DialogV2,
  },
  data() {
    const emptyForm = {
      from_name: '',
      email: '',
      forwarding: '',
    };
    return {
      emptyForm,
      form: {
        ...emptyForm,
      },
    };
  },
  computed: {
    title() {
      return `${!Object.keys(this.email).length ? 'Crear' : 'Editar'} email`;
    },
  },
  methods: {
    clearErrors() {
      Object.keys(this.form).forEach((key) => {
        this.$validator.errors.remove(key, this.validationScope);
      });
    },
    save() {
      this.$validator.validateAll(this.validationScope).then((validation) => {
        if (validation) {
          if (Object.keys(this.email).length) {
            this.axios.patch(`v2/company_emails/${this.email.id}`, this.form).then((response) => {
              this.$emit('updated', response.data);
              this.$emit('close');
            }).catch(() => {});
          } else {
            this.axios.post('v2/company_emails', this.form).then((response) => {
              this.$emit('created', response.data);
              this.$emit('close');
            }).catch(() => {});
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show && Object.keys(this.email).length) {
        this.form = _.clone(_.pick(this.email, Object.keys(this.emptyForm)));
      } else if (!this.show) {
        setTimeout(() => {
          this.form = {
            ...this.emptyForm,
          };
          this.clearErrors();
        }, 200);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Emails/Index.vue